var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"customize-theater d-flex justify-center full-width py-6 rounded-lg"},[_c('span',{staticClass:"mr-6 pa-1 font--title-medium"},[_vm._v("\n    "+_vm._s(_vm.$t('components.myTheater.customizeTheater'))+"\n  ")]),_vm._v(" "),_c(_setup.ComingSoonBox)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }